import React, { FC } from "react";
import SVGIcon from "./SVGIcon";
import classNames from "classnames";

type Props = {
  title: string;
  className?: string;
};
const EmptyState: FC<Props> = ({ title, className = "" }) => {
  return (
    <div
      className={classNames(
        "flex flex-col items-center justify-center gap-3 py-7.5 text-tertiary-500 dark:text-white opacity-25",
        className
      )}
    >
      <SVGIcon icon={"nodata"} className="w-16 h-16" />
      {title && <p className="text-base font-bold">{title}</p>}
    </div>
  );
};

export default EmptyState;
